import styled from "styled-components";
import { useState } from "react";

import NetworkInfo from "./NetworkInfo";
import UserInfo from "./UserInfo";
import Toolbar from "./Toolbar";
import NavContainer from "./NavContainer";
import NavSection from "./NavSection";
import Database from "./Database";
import Groups from "./Groups";
import Giving from "./Giving";
import Tools from "./Tools";
import Signups from "./Signups";

function App() {
  const [openTab, setOpenTab] = useState(false);

  return (
    <Wrapper>
      <Inside>
        <NetworkInfo />
        <Toolbar />
        <NavContainer>
          <NavSection
            openTab={openTab}
            setOpenTab={setOpenTab}
            tabKey="database"
            title="Household Database"
            icon="far fa-database"
            color="#D9705E"
            hasSettings
          >
            <Database />
          </NavSection>
          <NavSection
            openTab={openTab}
            setOpenTab={setOpenTab}
            tabKey="groups"
            title="Group Communication"
            icon="far fa-messages"
            color="#4E99D1"
          >
            <Groups />
          </NavSection>
          <NavSection
            openTab={openTab}
            setOpenTab={setOpenTab}
            tabKey="giving"
            title="Giving"
            icon="far fa-money-bill-wave"
            color="#84C760"
            hasSettings
          >
            <Giving />
          </NavSection>
          <NavSection
            openTab={openTab}
            setOpenTab={setOpenTab}
            tabKey="signups"
            title="Signups & Events"
            icon="far fa-clipboard-check"
            color="#FFB941"
          >
            <Signups />
          </NavSection>
          <NavSection
            openTab={openTab}
            setOpenTab={setOpenTab}
            tabKey="tools"
            title="Ministry Tools"
            icon="far fa-screwdriver-wrench"
            color="#8B169C"
          >
            <Tools />
          </NavSection>
        </NavContainer>
        <UserInfo />
      </Inside>
    </Wrapper>
  );
}

export default App;

const Wrapper = styled.div`
  width: 340px;
  height: 100vh;
  display: flex;
`;

const Inside = styled.div`
  flex-grow: 1;
  background: #182941;
  color: #f2f2f1;

  display: flex;
  flex-direction: column;

  position: relative;

  &:after {
    content: "";
    display: block;
    position: absolute;
    inset: 0;
    border-radius: inherit;
    z-index: 0;
    background: radial-gradient(
      calc(100vh * 0.6) circle at 125% 60%,
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0)
    );
  }
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 6px;
    background: red;
    background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
  }
`;
